module.exports = __webpack_public_path__ + "static/media/funnel-dollar.cbe85b1a.svg";